export default __webpack_public_path__ + "_/images/app/manual/manual2-b7762dcd7adf66a8402792436eb18ec6686d3c65c134aba8f9d760a1bb686238.png";